import { getTranslation } from '@lsoft/translate';
import _ from 'lodash';

const days = [
	{ DE: 'Sonntag', EN: 'Sunday', FR: 'Dimanche' },
	{ DE: 'Montag', EN: 'Monday', FR: 'Lundi' },
	{ DE: 'Dienstag', EN: 'Tuesday', FR: 'Mardi' },
	{ DE: 'Mittwoch', EN: 'Wednesday', FR: 'Mercredi' },
	{ DE: 'Donnerstag', EN: 'Thursday', FR: 'Jeudi' },
	{ DE: 'Freitag', EN: 'Friday', FR: 'Vendredi' },
	{ DE: 'Samstag', EN: 'Saturday', FR: 'Samedi' },
];

const order = [1, 2, 3, 4, 5, 6, 0];

const trSuffix = {
	DE: ' Uhr',
	EN: 'h',
	FR: 'h',
};

const trClosed = {
	DE: 'Geschlossen',
	EN: 'Closed',
	FR: 'Fermé',
};

function formatTime(close_time) {
	return [close_time.slice(0, 2), ':', close_time.slice(2)].join('');
}

const getLine = (d) => {
	const { close, open } = d;
	const { day, time: open_time } = open;
	const { time: close_time } = close;
	const close_time_string = formatTime(close_time);
	const open_time_string = formatTime(open_time);
	return {
		day,
		open_time_string,
		close_time_string,
	};
};

export const convert_places_opening_times = (periods, locale) => {
	const converted = periods.reduce((ret, p) => {
		const { day, open_time_string, close_time_string } = getLine(p);
		const suffix = getTranslation(trSuffix, locale);
		ret[
			day.toString()
		] = `${open_time_string}${suffix} - ${close_time_string}${suffix}`;
		return ret;
	}, {});
	const ret = order.map((idx) => {
		return {
			day_string: getTranslation(days[idx], locale),
			time_string: _.get(
				converted,
				idx.toString(),
				getTranslation(trClosed, locale)
			),
		};
	});
	return ret;
};
